var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyPageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.8125C11.8985 12.8125 13.4375 11.2735 13.4375 9.375C13.4375 7.47652 11.8985 5.9375 10 5.9375C8.10152 5.9375 6.5625 7.47652 6.5625 9.375C6.5625 11.2735 8.10152 12.8125 10 12.8125Z",
    fill: "#00AC97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1209 7.84638 17.2635 5.78216 15.7407 4.25932C14.2178 2.73648 12.1536 1.87913 10 1.875ZM15.1406 14.5625C14.6347 13.8368 13.9828 13.2247 13.2266 12.7656C12.3583 13.5974 11.2024 14.0618 10 14.0618C8.79762 14.0618 7.64168 13.5974 6.77344 12.7656C6.01725 13.2247 5.3653 13.8368 4.85938 14.5625C3.97952 13.5717 3.40473 12.3477 3.20419 11.0379C3.00365 9.7281 3.18591 8.38824 3.72903 7.17957C4.27214 5.97091 5.15298 4.94495 6.26553 4.22517C7.37807 3.50539 8.67492 3.12246 10 3.12246C11.3251 3.12246 12.6219 3.50539 13.7345 4.22517C14.847 4.94495 15.7279 5.97091 16.271 7.17957C16.8141 8.38824 16.9964 9.7281 16.7958 11.0379C16.5953 12.3477 16.0205 13.5717 15.1406 14.5625Z",
    fill: "#00AC97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPageActive);
export default __webpack_public_path__ + "static/media/my_page_active.45eec06f6cd315b7344057ca79564284.svg";
export { ForwardRef as ReactComponent };